import { CalculationModal } from "./modals/CalculationModal.tsx";
import { useModal } from "../util/modal/useModal.ts";
import { ModalType } from "../types/ModalType.ts";

export const Modals = () => {
  const { openModalType, closeModal } = useModal();

  return (
    <>
      {openModalType === ModalType.Calculation && (
        <CalculationModal onClose={closeModal} />
      )}

      {openModalType === ModalType.Calculation && <div>calc modal here</div>}
    </>
  );
};
